const importAll = (r) => {
    return r.keys().map(r);
}
module.exports = () => {
    return importAll(require.context("./", false, /\.(png|jpe?g|svg)$/));
}